module.exports = __webpack_public_path__ + "img/179.1b2d28c4.jpg";